module.exports = __webpack_public_path__ + "static/img/main_top_2.56b4053.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/main_top_2.png
// module id = l/vu
// module chunks = 1